<div
  class="block w-full relative"
  [ngStyle]="sectionMaxHeight && sectionMaxHeight !== 'none'
    ? { padding: linePadding, color: textColor, textAlign: textAlign, backgroundColor: backgroundColor, 'max-height': sectionMaxHeight, overflow: 'hidden' }
    : { padding: linePadding, color: textColor, textAlign: textAlign, backgroundColor: backgroundColor }"
>
  <ng-container *ngIf="bgMedia as m">
    <img *ngIf="m.type === 'IMAGE'"
      [src]="m | assetPreview:(isMobile ? 'medium': 'full'):'webp'"
      class="absolute inset-0 w-full h-full object-cover z-[1]"
      [style.object-position]="m | focalPoint"
      alt="Banner Background Image"
    />
    <video *ngIf="m.type === 'VIDEO' && m.mimeType === 'video/mp4'"
      [src]="m.source"
      class="absolute inset-0 w-full h-full object-cover z-[1]"
      autoplay
      muted
      loop
      playsinline
    ></video>
    <vsf-vimeo-player *ngIf="m.type === 'VIDEO' && m.mimeType === 'video/vimeo'"
      class="absolute inset-0 w-full h-full object-cover z-[1]"
      [source]="m.customFields?.videoUrl || m.source"
      [fullSection]="true"
      [previewImageUrl]="m.imageUrl || m.preview"
    ></vsf-vimeo-player>
    <div class="absolute inset-0 bg-gray-500 pointer-events-none z-[1]"
      [style.opacity]="shadowOpacity"
    ></div>
  </ng-container>

  <div class="max-w-6xl mx-auto relative z-[3]">
    <div>
      <vsf-title-box
        [titleInfo]="titleInfo"
        [forComponent]="true">
      </vsf-title-box>
    </div>

    <div class="border-current"
      [ngClass]="{
        'pl-6 border-l-4': textBarStyle === 'left',
        'pr-6 border-r-4': textBarStyle === 'right',
        '': textBarStyle === 'none',
      }">
      <h1 *ngIf="banner.title && titleInfo?.isPageHeading && titleInfo?.h1StyleMode !== 'sr-only'" class="font-bold mb-2 rich-text-content"
          [ngStyle]="isMobile
          ? { 'font-size.px': mobileTitleFontSize }
          : { 'margin-left': titleIndent, 'font-size.px': titleFontSize }"
          [innerHTML]="banner.title | safeHtml"
      ></h1>
      <div *ngIf="banner.title && (!titleInfo?.isPageHeading || titleInfo?.h1StyleMode === 'sr-only')" class="font-bold mb-2 rich-text-content"
          [ngStyle]="isMobile
          ? { 'font-size.px': mobileTitleFontSize }
          : { 'margin-left': titleIndent, 'font-size.px': titleFontSize }"
          [innerHTML]="banner.title | safeHtml"
      ></div>
      <div class="mb-4">
        <span class="rich-text-content"
          [ngStyle]="isMobile
          ? {'margin-left': descIndent,'width': descWidth,'font-size.px': mobileTextFontSize}
          : {'margin-left': descIndent,'width': descWidth,'font-size.px': textFontSize}"
          [innerHTML]="banner.text | safeHtml">
        </span>
      </div>
    </div>
  </div>
</div>
